import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-export-file-dialog',
  templateUrl: './export-file-dialog.component.html',
  styleUrls: ['./export-file-dialog.component.scss'],
  standalone: false,
})
export class ExportFileDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ExportFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
  ) {}

  onOkClick(): void {
    this.dialogRef.close();
  }
}
